<div class="verification-type">
  <p class="verification-instructions">{{ verificationDetails?.description }}</p>
  <a class="button button-pill button-verification" [routerLink]="verificationDetails?.route">
    {{ verificationDetails?.buttonText }}
  </a>
</div>
